import { Box }  from '@mui/material'
import { Icon } from 'components/Icons'
import React    from 'react'
import styled   from 'styled-components'

const Successfull = () => {
  return (
    <Section>
        <Box sx={{ maxWidth : '473px', width : '100%' }}>
            <Heading>
                <div className = "h2">Tak for din tilmelding!</div>
                <div className = "paragraph1-regular">Vi har modtaget din tilmelding og glæder os til at byde dig velkommen lørdag den 14. marts 2026.</div>
            </Heading>
            <BottomInfo>
                <div className = 'h4'>Detaljer om begivenheden</div>
                <Box sx={{ display: 'flex', gap: '8px', flexDirection: 'column'}}>
                    <Box  sx        = {{ display: "flex", flexDirection: "row", gap: "8px" }}>
                    <Icon isFaIcon  = "true" icon = "event-label" style = {{ width: "18px", height: "18px", fontSize: '16px' }} />
                    <p    className = "paragraph1-light">
                            Åbent hus - BF01
                            </p>
                    </Box>
                    <Box  sx        = {{ display: "flex", flexDirection: "row", gap: "8px" }}>
                    <Icon isFaIcon  = "true"  icon = "event-calendar" style = {{ width: "18px", height: "18px", fontSize: '16px' }} />
                    <p    className = "paragraph1-light">Lørdag den 14. marts 2026<br/>11:00 - 12:00 (1 time)</p>
                    </Box>
                    <Box  sx        = {{ display: "flex", flexDirection: "row", gap: "8px" }}>
                    <Icon isFaIcon  = "true"  icon             = "event-pin" style = {{ width: "18px", height: "18px", fontSize: '16px' }} />
                    <p    className = "paragraph2-light" style = {{ width: 'fit-content'}}>BF01 Travbyen vej 100 7100 Billund</p>
                    </Box>
                </Box>
            </BottomInfo>
        </Box>
    </Section>
  )
}

export default Successfull

const Section = styled.div`
  background-color: #F8F9F1;
  padding         : 16px 24px;
  height          : 720px;
  overflow-y      : auto;
  display         : flex;
  flex-direction  : column;
  justify-content : center;
  align-items     : center;
`

const Heading = styled.div`
    display       : flex;
    flex-direction: column;
    gap           : 16px;
    
    div {
        text-align: center;
    }
`

const BottomInfo = styled.div`
    display       : flex;
    flex-direction: column;
    gap           : 14px;
    margin-top    : 48px;

        
    div {
        text-align: center;
        justify-content: center;
        gap: 8px;
    }
`